export default "__VITE_ASSET__f6ff0295__"